import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { ITransitsAr } from "interfaces/transit-time-ar";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_TRANSITS_" }
);

export interface ListTransitsArState extends IState {
  data: ITransitsAr[];
}

interface ISuccessListTransitsArAction extends ISuccessAction {
  data: ITransitsAr[];
}

const INITIAL_STATE: ListTransitsArState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListTransitsArState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListTransitsArState, action: ISuccessListTransitsArAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListTransitsArState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listTransitsAr = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListTransitsArTypes = Types;
export const ListTransitsArActions = Creators;
